import { computed, inject } from 'vue';
import { useAuth } from '/app/composables/auth';
import { useFormContext } from '/app/composables/form';

export const usePreviewable = () => {
    const form = useFormContext();
    const builder = inject('builder', null);
    const { auth } = useAuth();

    const title = computed(() => {
        const t = form.fields.challenge.question_title;
        return t
            ? (String(t).includes('?') ? t : t + '?')
            : 'Your question will appear here as you fill it in...';
    });

    const category = computed(() => {
        const categories = builder?.categoryTree || [];
        return categories.length > 0 ? categories[categories.length - 1].name : 'Blank';
    });

    const image = computed(() => {
        let defaultImage = builder?.isQQ
            ? '/img/challenge-image-defaults/qq-challenge-image-default.jpg'
            : '/img/challenge-image-defaults/challenge-preview-placeholder.svg';
        return form.fields.challenge.primary_image || defaultImage;
    });

    const user = computed(() => {
        return auth.current.user;
    });

    const avatar = computed(() => {
        return user.value.avatar_url || '/img/user-profile-images/user-avatar-circle-anon.svg';
    });

    return { title, category, image, user, avatar };
};
